<template>
  <TimeslotDashboardLayout>
    <template v-slot:mobile-navbar>
      <div
        data-collapse="medium"
        data-animation="over-left"
        data-duration="400"
        data-w-id="df38f32a-3fbb-f2fb-24e9-fdc828eab25c"
        data-easing="ease"
        data-easing2="ease"
        role="banner"
        class="navbar-mobile w-nav"
      >
        <div class="navbar1_container">
          <router-link
            to="/professional-dashboard"
            class="navbar1_logo-link w-nav-brand"
          >
            <img
              src="@/assets/timeslot-images/timeslate-logo.svg"
              loading="lazy"
              alt=""
              class="navbar1_logo"
          /></router-link>

          <div
            @click="showNav"
            class="navbar1_menu-button w-nav-button"
            style="-webkit-user-select: text;"
            aria-label="menu"
            role="button"
            tabindex="0"
            aria-controls="w-nav-overlay-0"
            aria-haspopup="menu"
            aria-expanded="false"
          >
            <div class="menu-icon1">
              <div class="menu-icon1_line-top"></div>
              <div class="menu-icon1_line-middle">
                <div class="menu-icon_line-middle-inner"></div>
              </div>
              <div class="menu-icon1_line-bottom"></div>
            </div>
          </div>
        </div>
        <div
          v-if="cross"
          class="w-nav-overlay"
          data-wf-ignore=""
          id="w-nav-overlay-0"
          style="height: 100vh; display: block; width: 100%;"
        >
          <nav
            role="navigation"
            class="navbar1_menu w-nav-menu"
            style="transform: translateX(0px) translateY(0px);  height: 100vh; transition: transform 400ms ease 0s;"
            data-nav-menu-open=""
          >
            <div class="div-block-4-copy top">
              <div
                data-w-id="df38f32a-3fbb-f2fb-24e9-fdc828eab262"
                class="link-block-3 w-inline-block"
                @click="closeNav"
              >
                <img
                  src="@/assets/timeslot-images/cancel.svg"
                  loading="lazy"
                  alt=""
                />
              </div>
              <div class="div-block-51">
                <div class="div-block-5-copy">
                  <div class="div-block-6-copy">
                    <img
                      v-if="'customerDisplayPicture' in customerInfo"
                      class="image-profile-pic"
                      :src="customerInfo.customerDisplayPicture"
                    />
                    <div class="text-block-8" v-else>
                      {{ userInfo.customerFirstName.charAt(0)
                      }}{{ userInfo.customerLastName.charAt(0) }}
                    </div>
                  </div>
                  <div class="div-block-28">
                    <div class="text-block-6">
                      {{ userInfo.customerFirstName }}
                      {{ userInfo.customerLastName }}
                    </div>
                    <div class="text-block-7">
                      <a @click="goToProfile" class="link-18">View profile</a>
                    </div>
                  </div>
                </div>
                <div class="div-block-29">
                  <router-link
                    to="/professional-dashboard"
                    aria-current="page"
                    class="link-block-4 dashboard w-inline-block w--current"
                  >
                    <div class="text-block-27">Dashboard</div>
                  </router-link>
                  <router-link
                    to="/professional-messages"
                    class="link-block-4 message w-inline-block"
                  >
                    <div class="text-block-27">Messages</div>
                  </router-link>
                  <router-link
                    to="/professional-bookings"
                    class="link-block-4 booking w-inline-block"
                  >
                    <div class="text-block-27">Bookings</div>
                  </router-link>

                  <router-link
                    to="/professional-classes"
                    class="link-block-4 classes w-inline-block"
                  >
                    <div class="text-block-27">My Classes</div>
                  </router-link>

                  <router-link
                    to="/professional-subscriptions"
                    class="link-block-4 feeds w-inline-block"
                  >
                    <div class="text-block-27">Subscriptions</div>
                  </router-link>
                  <router-link
                    to="/professional-availability"
                    class="link-block-4 availability w-inline-block"
                  >
                    <div class="text-block-27">Available slots</div>
                  </router-link>
                  <router-link
                    to="/professional-wallet"
                    class="link-block-4 wallet w-inline-block"
                  >
                    <div class="text-block-27">Wallet</div>
                  </router-link>
                  <router-link
                    to="/professional-settings"
                    class="link-block-4 settings w-inline-block"
                  >
                    <div class="text-block-27">Settings</div>
                  </router-link>
                  <router-link
                    to="/professional-notifications"
                    class="link-block-4 discover w-inline-block"
                  >
                    <div class="text-block-27">Notifications</div>
                  </router-link>
                </div>
                <div class="div-block-29-copy">
                  <router-link
                    to="/discover-professionals"
                    class="link-block-4 conection w-inline-block"
                  >
                    <div class="text-block-27">Discover</div>
                  </router-link>
                  <router-link
                    to="/professional-support"
                    class="link-block-4 support w-inline-block"
                  >
                    <div class="text-block-27">Support</div>
                  </router-link>
                  <a
                    @click="logout"
                    class="link-block-4 log-out w-inline-block"
                  >
                    <div class="text-block-27">Log out</div>
                  </a>
                </div>
              </div>
            </div>
            <div></div>
          </nav>
        </div>
      </div>
    </template>
    <template v-slot:app-navbar>
      <ProfessionalAppNavBar />
    </template>
    <template v-slot:sidebar>
      <ProfessionalSidebar />
    </template>
    <div class="main-content booking create-class-page">
      <div style="display:flex; justify-content: flex-start">
        <div class="modal__header__back-arrow class-arrow">
          <a @click="backArrowAction"
            ><img src="@/assets/timeslot-images/left-arrow-circled.svg"
          /></a>
        </div>
        <div class="content-div class-form">
          <div class="my-class-div">
            <h1 class="tab-heading">Create Class</h1>
          </div>
          <div>
            <FormulateForm style="width: 100%; margin-top:20px;">
              <div class="field">
                <div class="text-block-48">Topic</div>
                <!--                <FormulateInput-->
                <!--                    id="topic-textarea"-->
                <!--                  type="textarea"-->

                <!--                  v-model="createClassModel.groupSessionTopic"-->
                <!--                  @input="getWordCount"-->
                <!--                  validation="required"-->
                <!--                  validation-name="Topic"-->
                <!--                />-->
                <textarea
                  id="field-3"
                  name="field-3"
                  @input="getWordCount"
                  rows="5"
                  cols="10"
                  maxlength="5000"
                  data-name="field"
                  style="height:100px; margin-bottom:20px;"
                  placeholder="Enter topic"
                  class="text-field rich-text w-input"
                  v-model="createClassModel.groupSessionTopic"
                  required
                  @mouseleave="showWordCount = false"
                ></textarea>
                <div
                  v-if="showMaxWordCountError"
                  style="display:flex; justify-content: flex-start; color:red; font-size:12px;margin-bottom:10px;"
                >
                  Topic must not exceed 150 characters
                </div>
                <div
                  v-if="showWordCount && !showMaxWordCountError"
                  style="display:flex; justify-content: flex-end; position:relative; top:-15px;"
                >
                  {{ getWordCount() }} / 150
                </div>
              </div>
              <div style="display: flex; justify-content: space-between; ">
                <div class="field" style="width:48%;">
                  <div class="text-block-48">Date</div>
                  <FormulateInput
                    type="date"
                    placeholder="12/12/20"
                    v-model="classDate"
                    validation="required"
                    validation-name="Date"
                    id="class-date"
                  />
                </div>
                <div class="field" style="width:48%;">
                  <div class="text-block-48">Max. no of Students</div>
                  <FormulateInput
                    type="number"
                    v-model="createClassModel.groupSessionMaxAttendance"
                  />
                </div>
              </div>
              <div style="display: flex; justify-content: space-between; ">
                <div class="field" style="width:48%;">
                  <div class="text-block-48">Start time</div>
                  <FormulateInput
                    type="time"
                    v-model="start"
                    validation="required"
                    validation-name="Start time"
                  />
                </div>
                <div class="field" style="width:48%;">
                  <div class="text-block-48">End time</div>
                  <FormulateInput
                    type="time"
                    v-model="end"
                    validation="required"
                    validation-name="End time"
                  />
                </div>
              </div>
              <div class="field">
                <div class="text-block-48">Set Price</div>
                <FormulateInput
                  type="number"
                  v-model="createClassModel.groupSessionAmount"
                  placeholder="$0.00"
                />
              </div>
              <div class="field">
                <div class="text-block-48">Description</div>
                <FormulateInput
                  type="textarea"
                  v-model="createClassModel.groupSessionDescription"
                />
              </div>
            </FormulateForm>
            <BaseComponentLoader
              v-if="loader.nonBlockingLoader"
              loaderAlignment="center"
            />
            <div style="display:flex; justify-content: center" v-else>
              <FormulateInput
                type="submit"
                label="Proceed"
                style="width:50%"
                @click="createClass"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <SuccessMessageModal
      :is-open="classCreatedSuccess"
      :message="'You have created a class successfully!'"
      :button-action="closeSuccess"
      :cancel="closeSuccess"
    />
    <template v-slot:right-side-nav>
      <ProfRightSideMenu />
    </template>
  </TimeslotDashboardLayout>
</template>

<script>
import TimeslotDashboardLayout from "@/views/timeslot/TimeslotDashboardLayout";
import ProfRightSideMenu from "@/views/timeslot/ProfRightSideMenu";
import ProfessionalAppNavBar from "@/components/navbar/ProfessionalAppNavBar";
import ProfessionalSidebar from "@/views/timeslot/ProfessionalSidebar";
import CreateClassModal from "@/components/modal/CreateClassModal";
import GroupSessionRequest from "@/model/requests/GroupSessionRequest";
import RouterUtils from "@/utils/BaseUtils/RouterUtils";
import { mapState } from "vuex";
import BaseComponentLoader from "@/components/BaseComponents/BaseComponentLoader";
import StoreUtils from "@/utils/BaseUtils/StoreUtils";
import SuccessMessageModal from "@/components/modal/SuccessMessageModal";
export default {
  name: "CreateClassPage",
  components: {
    SuccessMessageModal,
    BaseComponentLoader,
    ProfRightSideMenu,
    TimeslotDashboardLayout,
    ProfessionalAppNavBar,
    ProfessionalSidebar
  },
  data() {
    return {
      createClassModel: GroupSessionRequest.create,
      bar: true,
      cross: false,
      classDate: new Date(),
      start: "00:00",
      end: "00:00",
      showWordCount: false,
      showMaxWordCountError: false
    };
  },
  computed: {
    combinedDateTimeStart() {
      return `${this.classDate} ${this.start}:00.000`;
    },
    combinedDateTimeEnd() {
      return `${this.classDate} ${this.end}:00.000`;
    },
    ...mapState({
      userInfo: state => state.auth.userInfo,
      customerToProfessionalId: state =>
        state.professional.customerToProfessionalId,
      classCreatedSuccess: state => state.groupSession.classCreatedSuccess,
      customerInfo: state => state.customer.customerInfo
    }),
    ...mapState(["loader"])
  },
  methods: {
    getWordCount() {
      this.showWordCount = true;
      if (this.createClassModel.groupSessionTopic !== null) {
        return this.createClassModel.groupSessionTopic.length;
      } else {
        return 0;
      }
    },
    showNav() {
      this.cross = true;
      this.bar = false;
    },
    closeNav() {
      this.bar = true;
      this.cross = false;
    },
    backArrowAction() {
      RouterUtils.goBackOnce();
    },
    createClass() {
      this.createClassModel.groupSessionStartTime = this.combinedDateTimeStart;
      this.createClassModel.groupSessionEndTime = this.combinedDateTimeEnd;
      if ("professional" in this.userInfo) {
        this.createClassModel.groupSessionProfessionalId = this.userInfo.professional.professionalId;
      } else {
        this.createClassModel.groupSessionProfessionalId = this.customerToProfessionalId;
      }
      StoreUtils.dispatch(
        "groupSession/createGroupSession",
        this.createClassModel
      ).then(() => {
        this.createClassModel = {
          groupSessionTopic: null,
          groupSessionDescription: null,
          groupSessionProfessionalId: null,
          groupSessionStartTime: null,
          groupSessionEndTime: null,
          groupSessionAmount: null,
          groupSessionImage: null,
          groupSessionRequirements: null,
          groupSessionMaxAttendance: null
        };
      });
    },
    closeSuccess() {
      StoreUtils.commit("groupSession/updateClassCreatedSuccess", false);
      RouterUtils.changeRouteUrlTo("/professional-classes");
      this.createClassModel.groupSessionTopic = null;
      this.createClassModel.groupSessionMaxAttendance = null;
      this.createClassModel.groupSessionAmount = null;
      this.createClassModel.groupSessionDescription = null;
    },
    goToProfile() {
      RouterUtils.changeRouteUrlTo(`/professionals/${this.professionalId}`);
    },
    logout() {
      StoreUtils.dispatch(StoreUtils.actions.auth.LOGOUT);
    }
  },
  watch: {
    "createClassModel.groupSessionTopic"(newValue) {
      if (newValue.length > 150) {
        this.showMaxWordCountError = true;
      } else {
        this.showMaxWordCountError = false;
      }
    }
  }
};
</script>

<style scoped>
.field {
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
}
.create-class-page {
  width: 70%;
}
.class-arrow {
  width: 10%;
}
.class-form {
  width: 80%;
}
@media only screen and (max-width: 912px) {
  .create-class-page {
    width: 100%;
  }
  .class-arrow {
    width: 15%;
  }
  .class-form {
    width: 85%;
  }
}
</style>
